import { apiConfig } from "./apiConfig";

const searchUrl = apiConfig.oftheday.search;

export const getSearchResults = (axios, terms) => axios.get(`${searchUrl}?page=1&terms=${terms}`);
